import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import categoryApi from "../api/product/categoryApi";
import productApi from "../api/product/productApi";

// create slice
const name = "product";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const productActions = { ...slice.actions, ...extraActions };
export const productReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    productSelectOrder: [],
    productSelects: [],
    lstCategory: [],
    totalCount: 0,
    lstProduct: [],
    totalCountProducts: 0,
  };
}

function createExtraActions() {
  return {
    getCategories: getCategories(),
    getProducts: getProducts(),
  };

  function getCategories() {
    return createAsyncThunk(
      `${name}/getCategories`,
      async (params) => await categoryApi.getCategories(params)
    );
  }

  function getProducts() {
    return createAsyncThunk(
      `${name}/getProducts`,
      async (params) => await productApi.getProducts(params)
    );
  }
}

function createReducers() {
  return {
    setProductSelectOrder,
    setProductSelects
  };

  function setProductSelectOrder(state, action) {
    state.productSelectOrder = action.payload;
  }
  function setProductSelects(state, action) {
    state.productSelects = action.payload;
  }
}

function createExtraReducers() {
  return {
    ...getCategories(),
    ...getProducts(),
  };

  function getCategories() {
    const { pending, fulfilled, rejected } = extraActions.getCategories;
    return {
      [pending]: (state) => {
        state.lstCategory = [];
      },
      [fulfilled]: (state, action) => {
        const data = action.payload;
        state.lstCategory = data.results;
        state.totalCount = data.totalResults;
      },
      [rejected]: (state, action) => {
        state.lstCategory = [];
      },
    };
  }

  function getProducts() {
    const { pending, fulfilled, rejected } = extraActions.getProducts;
    return {
      [pending]: (state) => {
        state.lstProduct = [];
      },
      [fulfilled]: (state, action) => {
        const data = action.payload;
        state.lstProduct = data.results;
        state.totalCountProducts = data.totalResults;
      },
      [rejected]: (state, action) => {
        state.lstProduct = [];
      },
    };
  }
}
